import autobind from 'class-autobind';

import EventTarget from '@/util/EventTarget';
import { findUpTagByClass } from '@/util/findUpTag';
import { getMaxRectInBounds } from '@/util/bounds';


export default class NotecardHandler {
   constructor(host) {
        autobind(this);

        this.host = host;
   }

   tap(event) {
        console.log('notecard handler tap', event);

        let gestureTarget = event.detail.gestureStartTarget;

        const isBackground = (gestureTarget && gestureTarget.className && gestureTarget.className.split) ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false; //fillContainer
        if (!isBackground) {
            return;
        }

        const cursorX = ((this.host.pointerX - this.host.props.width/2) / this.host.props.scale) - this.host.props.panX;
        const cursorY = ((this.host.pointerY - this.host.props.height/2) / this.host.props.scale) - this.host.props.panY;

        //contentW, contentH, boundingW, boundingH
        const bounds = getMaxRectInBounds(
            100/ this.host.props.scale,
            100/ this.host.props.scale,

            100/ this.host.props.scale,
            100/ this.host.props.scale
        );

        this.host.props.addNotecard(
            cursorX-(bounds.width/2),
            cursorY-(bounds.height/2),
            bounds.width,
            bounds.height
        );
    }

    change(event) {
        let gestureTarget = event.detail.gestureStartTarget;

        const isBackground = (gestureTarget && gestureTarget.className && gestureTarget.className.split) ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false; //fillContainer
        if (!isBackground) {
            return;
        }

        const startX = (event.detail.start.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
        const startY = (event.detail.start.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;

        const endX = (event.detail.current.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
        const endY = (event.detail.current.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;

        const boundingBox = {
            minX: Math.min(startX, endX),
            minY: Math.min(startY, endY),
            maxX: Math.max(startX, endX),
            maxY: Math.max(startY, endY)
        };

        //contentW, contentH, boundingW, boundingH
        const contentBox = getMaxRectInBounds(
            1,
            1,

            boundingBox.maxX - boundingBox.minX,
            boundingBox.maxY - boundingBox.minY
        );

        // console.log('set marquee', bounds);
        const x = boundingBox.minX == startX ? startX : startX - contentBox.width; // boundingBox.minX //+ (boundingBox.maxX-boundingBox.minX)//-contentBox.width)/2;
        const y = boundingBox.minY == startY ? startY : startY - contentBox.height; // boundingBox.minY //+ (boundingBox.maxX-boundingBox.minY)//-contentBox.height)/2;

        console.log(x, y, contentBox);

        this.host.props.setNotecardPreview({
            minX: x,
            minY: y,
            maxX: x + contentBox.width,
            maxY: y + contentBox.height
        });
    }

    enddrag(event) {

        let gestureTarget = event.detail.gestureStartTarget;

        const isBackground = (gestureTarget && gestureTarget.className && gestureTarget.className.split) ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false; //fillContainer
        if (!isBackground) {
            return;
        }
        


        const startX = (event.detail.start.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
        const startY = (event.detail.start.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;

        const endX = (event.detail.end.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
        const endY = (event.detail.end.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;

        const boundingBox = {
            minX: Math.min(startX, endX),
            minY: Math.min(startY, endY),
            maxX: Math.max(startX, endX),
            maxY: Math.max(startY, endY)
        };

        //contentW, contentH, boundingW, boundingH
        const contentBox = getMaxRectInBounds(
            1,
            1,

            boundingBox.maxX - boundingBox.minX,
            boundingBox.maxY - boundingBox.minY
        );


        // console.log('set marquee', bounds);
        const x = boundingBox.minX == startX ? startX : startX - contentBox.width; // boundingBox.minX //+ (boundingBox.maxX-boundingBox.minX)//-contentBox.width)/2;
        const y = boundingBox.minY == startY ? startY : startY - contentBox.height; // boundingBox.minY //+ (boundingBox.maxX-boundingBox.minY)//-contentBox.height)/2;

            console.log(x, y, contentBox);

        var action = this.host.props.addNotecard(
            x,
            y,
            contentBox.width,
            contentBox.height
        );

        console.log ('action', action);

        // this.host.props.activate(gestureTarget.id);

        this.host.props.setNotecardPreview();
        
    }
};